import { PaletteMode, useTheme } from '@mui/material';

export const useOppositeColorMode = (): PaletteMode => {
  const {
    palette: { mode },
  } = useTheme();

  return mode === 'dark' ? 'light' : 'dark';
};
